import { render, staticRenderFns } from "./DetailsSalesOrder.vue?vue&type=template&id=c22d80e8&"
import script from "./DetailsSalesOrder.vue?vue&type=script&lang=js&"
export * from "./DetailsSalesOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports